var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"db-tableau"},[(_vm.url==='' || _vm.token==='')?_c('p',[_vm._v("Loading...")]):_vm._e(),_c('div',{ref:"tableauViz",staticStyle:{"width":"100%","height":"827px"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }